export default {
    titleFontSize: '18px',
    backSize: '22px'
};
